export const PA_DATA_REQUEST = 'PA_DATA_REQUEST';
export const PA_DATA_SUCCESS = 'PA_DATA_SUCCESS';
export const PA_DATA_FAIL = 'PA_DATA_FAIL';
